import Vue from 'vue'
import {
  VTooltip,
  Tooltip
} from 'floating-vue'

Vue.directive('tooltip', VTooltip)
Vue.component('Tooltip', Tooltip)
